import { API__PROJECTS, API__TYPES, API__SHARE } from '../api/'
import { getConfig } from '../utils/productConfig'

let params = {}

/**
 *
 * @param {boolean} useGuid использовать ли id в формате D6B52ACF-DF35-4BA4-B19D-96F293896AC3 для нового проекта
 */
export const setup = ({
    apiServer,
    projectId,
    numberId,
    projectTypeId,
    currentVersionId,
    useGuid = true,
    projectActions,
    projectForms = [],
    sharingLinkRedirectUrl = null,
}) => {
    params = {
        apiServer,
        projectId,
        numberId,
        projectTypeId,
        currentVersionId,
        useGuid,
        projectActions,
        projectForms,
        sharingLinkRedirectUrl,
    }
}

export const setProjectJson = json => {
    params.projectStructureJson = json
}

export const setProjectName = name => {
    params.name = name
}

export const setProjectTitle = title => {
    params.title = title
}

export const setProjectDescription = description => {
    params.description = description
}

export const setProjectImage = (id, url) => {
    params.imageId = id
    params.imageUrl = url
}

export const setProjectCustomImageSelected = value => {
    params.customImageSelected = value
}

const getUpdatedProjectForms = (projectForms, projectStructureJson) => {
    if (
        projectStructureJson &&
        projectStructureJson.app &&
        projectStructureJson.app.userForm &&
        projectStructureJson.app.userForm.enable
    ) {
        return projectForms.length ? projectForms : projectFormsDefault
    } else {
        return []
    }
}

/**
 * Сохранить проект
 * В зависимости от того, новый это проект или нет - будет вызвано создание нового проекта либо обновление существующего.
 */
export const save = async () => {
    let response = null

    const structureToSave = JSON.parse(JSON.stringify(params.projectStructureJson))
    encodeAllHtmlStringsInObject(structureToSave)

    if (params.projectId && params.numberId) {
        // проект уже существует - обновляем
        response = await API__PROJECTS.UPDATE_PROJECT(params.projectId, {
            id: params.numberId, // нужен здесь для подтверждения, генерируется бекендом при создании проекта
            projectId: params.projectId,
            projectType: {
                id: params.projectTypeId,
            },
            projectStructureJson: structureToSave,
            projectActions: params.projectActions.length ? params.projectActions : projectActionsDefault,
            sharingLinkRedirectUrl: params.sharingLinkRedirectUrl,
            projectForms: getUpdatedProjectForms(params.projectForms, params.projectStructureJson),
            name: params.name,
            title: params.title,
            description: params.description,
            imageId: params.imageId,
            imageUrl: params.imageUrl,
            customImageSelected: params.customImageSelected,
        })
    } else {
        // проект новый - генерируем под него id
        if (params.useGuid) {
            params.projectId = uuidv4()
        } else {
            // этот короткий id нужен для старого редактора. В новом будет полный id
            params.projectId = uuidShort()
        }
        response = await API__PROJECTS.SAVE_PROJECT({
            id: null, // id - числовой id, который присваивается на сервере
            projectId: params.projectId,
            projectType: {
                id: params.projectTypeId, // уникальный ид типа проекта
                //"currentVersionId": params.currentVersionId // передавать не нужно, но использовалась ранее, сейчас может быть только одна версия текущая, установленная через админку
            },
            projectStructureJson: structureToSave,
            projectActions: projectActionsDefault,
            sharingLinkRedirectUrl: params.sharingLinkRedirectUrl,
            projectForms: getUpdatedProjectForms([], params.projectStructureJson),
            name: params.name,
            title: params.title,
            description: params.description,
            imageId: params.imageId,
            imageUrl: params.imageUrl,
            customImageSelected: false,
        })
    }
    return {
        numberId: response.id,
        projectId: response.projectId,
        response: response,
    }
}

/**
 * Запросить файлы типа проекта загруженные через админку
 * Будут возвращены файлы для самой актуальной версии
 *
 * @param {String} projectId
 */
export const getProject = async projectId => {
    const resp = await API__PROJECTS.GET_PROJECT(projectId)
    decodeAllHtmlStringsInObject(resp.projectStructureJson)
    return resp
}

/**
 * Привязать превью картинку к проекту
 *
 * @param {string} project_id
 * @param {string} image_id
 */
export const setProjectPreviewImage = async (project_id, image_id) => {
    return await API__PROJECTS.SET_PROJECT_PREVIEW_IMAGE(project_id, image_id)
}

/**
 * Загрузить информацию по шаблону. Внутри содержится информация о типа проекта также
 *
 * @param {string} templateId
 */
export const getTemplate = async templateId => {
    return await API__TYPES.GET_TEMPLATE(templateId)
}

/**
 *
 * @param {string} url
 */
export const getText = async url => {
    const resp = await fetch(url, {
        // mode: 'cors',
        // headers: {
        //     "Access-Control-Allow-Origin": "*"
        // }
    })
    if (resp.ok) {
        return await resp.text()
    }
    return null
}

/**
 * Опубликовать проект.
 * Используются загруженный файлы проекта: html, js, css и также json проекта
 *
 * projectStructureJson встравляется в html контент на месте якоря
 *
 * From the backed:
 * private static final String ARGUMENT_TO_INSERT_JSON = "{{PROJECT_STRUCTURE_JSON}}";
 * ...
 * htmlContent = htmlContent.replace(ARGUMENT_TO_INSERT_JSON, project.getProjectStructure());
 * ...
 */
export const publish = async () => {
    return await API__PROJECTS.PUBLISH(params.projectId)
}

export const createShareEntities = async entities => {
    return await API__PROJECTS.SHARE(params.numberId, entities)
}

export const getContentLink = () => {
    return `${params.apiServer}/api/projects/${params.projectId}/versions/${params.currentVersionId}/content`
}

export const getEmbedCode = custom_id => {
    const loader = `//${window.location.host}/legacy/editor_assets/js/l.js`
    const hattr = custom_id && getConfig(custom_id).height === 'auto' ? 'data-h="auto"' : ''
    return `<div class="rmx_interacty" ${hattr} data-content="${getContentLink()}"><script src="${loader}" async></script></div>`
}

export const getEmbedCodePlain = (project_id, version_id, custom_id) => {
    if (custom_id === 'IP_TEST') {
        const loader = `${process.env.REACT_APP_BACKEND_URL.replace('api.', '')}/static/loader.js`
        const content = `${process.env.REACT_APP_BACKEND_URL}/api/projects/${project_id}/versions/${version_id}/content`
        return `<div class="remix-app" content="${content}"><script src="${loader}" async></script></div>`
    } else {
        const loader = `//${window.location.host}/legacy/editor_assets/js/l.js`
        const hattr = custom_id && getConfig(custom_id).height === 'auto' ? 'data-h="auto"' : ''
        return `<div class="rmx_interacty" ${hattr} data-content="${process.env.REACT_APP_BACKEND_URL}/api/projects/${project_id}/versions/${version_id}/content"><script src="${loader}" async></script></div>`
    }
}

export const getEmbedDynamically = (container, project, contentDirectLink = null) => {
    if (project && project.projectType.customId === 'IP_TEST') {
        const div = document.createElement('div'),
            script = document.createElement('script')

        div.setAttribute('class', 'remix-app')
        if (contentDirectLink) {
            div.setAttribute('content', contentDirectLink)
        } else {
            div.setAttribute(
                'content',
                `${process.env.REACT_APP_BACKEND_URL}/api/projects/${project.projectId}/versions/${project.latestProjectVersionId}/content`,
            )
        }
        script.src = `${process.env.REACT_APP_BACKEND_URL.replace('api.', '')}/static/loader.js`
        script.async = true
        div.appendChild(script)
        container.appendChild(div)
    } else {
        const div = document.createElement('div'),
            script = document.createElement('script')
        div.setAttribute('class', 'rmx_interacty')
        if (contentDirectLink) {
            div.setAttribute('data-content', contentDirectLink)
        } else {
            div.setAttribute(
                'data-content',
                `${process.env.REACT_APP_BACKEND_URL}/api/projects/${project.projectId}/versions/${project.latestProjectVersionId}/content`,
            )
        }
        script.src = `//${window.location.host}/legacy/editor_assets/js/l.js`
        script.async = true
        div.appendChild(script)
        container.appendChild(div)
    }
}

export const getLink = id => {
    //TODO
    return `https://interacty.me/12345todo`
}

/**
 * From https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
export const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
}

const uuidShort = () => {
    return uuidv4().substr(0, 8)
}

export const getPlainTextFromHtml = str => {
    ;[`\n`, `\r`, `\``, `'`, `"`, `<`, `>`].forEach(char => {
        const reg = new RegExp(`U\\+${char.charCodeAt(0)};`, 'g')
        str = str.replace(reg, char).replace(/(<([^>]+)>)/gi, '')
    })
    return str
}

const encodeChars = [`\n`, `\r`, `\``, `'`, `"`, `<`, `>`]

export function htmlEncode(html) {
    encodeChars.forEach(char => {
        const reg = new RegExp(char, 'g')
        html = html.replace(reg, `U+${char.charCodeAt(0)};`)
    })
    return html
}

export function htmlDecode(str) {
    encodeChars.forEach(char => {
        const reg = new RegExp(`U\\+${char.charCodeAt(0)};`, 'g')
        str = str.replace(reg, char)
    })
    return str
}

export function decodeAllHtmlStringsInObject(obj) {
    forAllStringProperties(obj, htmlDecode)
}

export function encodeAllHtmlStringsInObject(obj) {
    forAllStringProperties(obj, htmlEncode)
}

function forAllStringProperties(obj, fn) {
    Object.keys(obj).forEach(k => {
        if (typeof obj[k] === 'string') {
            obj[k] = fn(obj[k])
        } else if (typeof obj[k] === 'object') {
            forAllStringProperties(obj[k], fn)
        }
    })
}

export const projectActionsDefault = [
    {
        id: null,
        actionType: 'EXTERNAL_LINK',
        name: 'External link',
    },
    {
        id: null,
        actionType: 'SEND_FORM',
        name: 'Send form',
    },
    {
        id: null,
        actionType: 'LOGO_CLICK',
        name: 'Click on logo',
    },
    {
        id: null,
        actionType: 'TEST_RESULT_DOWNLOADED',
        name: 'Download',
    },
]

export const projectFormsDefault = [
    {
        id: null,
        name: 'Base Form',
        fields: [
            {
                id: null,
                name: 'First name',
                fieldType: 'NAME',
                required: false,
            },
            {
                id: null,
                name: 'Last name',
                fieldType: 'LAST_NAME',
                required: false,
            },
            {
                id: null,
                name: 'Email',
                fieldType: 'EMAIL',
                required: false,
            },
            {
                id: null,
                name: 'Phone',
                fieldType: 'PHONE',
                required: false,
            },
        ],
    },
]

const Publisher = {
    setup,
    setProjectJson,
    setProjectName,
    save,
    publish,
    getEmbedCode,
    getEmbedDynamically,
    getLink,
    getTemplate,
    getText,
    uuidv4,
}

export default Publisher
